<template>
  <div id="china_map_box">
    <div id="china_map"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import 'echarts/map/js/china.js'
import {getTimeArea} from "@/api/area/china";

var myChart;


export default {
  data() {
    return {
      //echart 配制option
      options: {
        tooltip: {
          triggerOn: "mousemove",   //mousemove、click
          padding: 8,
          borderWidth: 1,
          borderColor: '#409eff',
          backgroundColor: 'rgba(255,255,255,0.7)',
          textStyle: {
            color: '#000000',
            fontSize: 13
          },
          formatter: function (e) {
            let data = e.data;
            //模拟数据
            data.specialImportant = Math.random() * 1000 | 0;
            data.import = Math.random() * 1000 | 0;
            data.compare = Math.random() * 1000 | 0;
            data.common = Math.random() * 1000 | 0;
            data.specail = Math.random() * 1000 | 0;

            let context = `
               <div>
                   <p><b style="font-size:15px;">${data.name}</b>(检测次数)</p>
                   <p class="tooltip_style"><span class="tooltip_left">事件总数</span><span class="tooltip_right">${data.value}</span></p>
                   <!-- <p class="tooltip_style"><span class="tooltip_left">特别重大事件</span><span class="tooltip_right">${data.specialImportant}</span></p>
                   <p class="tooltip_style"><span class="tooltip_left">重大事件</span><span class="tooltip_right">${data.import}</span></p>
                   <p class="tooltip_style"><span class="tooltip_left">较大事件</span><span class="tooltip_right">${data.compare}</span></p>
                   <p class="tooltip_style"><span class="tooltip_left">一般事件</span><span class="tooltip_right">${data.common}</span></p>
                   <p class="tooltip_style"><span class="tooltip_left">特写事件</span><span class="tooltip_right">${data.specail}</span></p> -->
               </div>
            `
            return context;
          }
        },
        visualMap: {
          show: true,
          left: 26,
          bottom: 10,
          showLabel: true,
          pieces: [
            {
              gte: 100,
              label: ">= 1000",
              // color: "#1f307b"
              color: "#0033FF"
            },
            {
              gte: 500,
              lt: 999,
              label: "500 - 999",
              // color: "#3c57ce"
              color: "#0066FF"
            },
            {
              gte: 100,
              lt: 499,
              label: "100 - 499",
              // color: "#6f83db"
              color: "#0099FF"
            },
            {
              gte: 10,
              lt: 99,
              label: "10 - 99",
              // color: "#9face7"
              color: "#00CCFF"
            },
            {
              lt: 10,
              label: '<10',
              // color: "#bcc5ee"
              color: "#00FFFF"
            }
          ]
        },
        geo: {
          map: "china",
          scaleLimit: {
            min: 1.2,
            max: 2
          },
          zoom: 1,
          top: 80,
          label: {
            normal: {
              show: true,
              fontSize: "14",
              color: "rgba(0,0,0,0.7)"
            }
          },
          itemStyle: {
            normal: {
              //shadowBlur: 50,
              //shadowColor: 'rgba(0, 0, 0, 0.2)',
              borderColor: "rgba(0, 0, 0, 0.2)"
            },
            emphasis: {
              areaColor: "#f2d5ad",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0
            }
          }
        },
        series: [
          {
            name: "突发事件",
            type: "map",
            geoIndex: 0,
            data: []
          }
        ]
      },
      //echart data
      dataList: [
        {
          name: "南海诸岛",
          area: 0,
          value: 100,
          // eventTotal: 100,
          // specialImportant: 10,
          // import: 10,
          // compare: 10,
          // common: 40,
          // specail: 20
        },
        {
          name: "北京",
          area: 11,
          value: 0
        },
        {
          name: "天津",
          area: 12,
          value: 0
        },
        {
          name: "上海",
          area: 31,
          value: 0
        },
        {
          name: "重庆",
          area: 50,
          value: 0
        },
        {
          name: "河北",
          area: 13,
          value: 0
        },
        {
          name: "河南",
          area: 41,
          value: 0
        },
        {
          name: "云南",
          area: 53,
          value: 0
        },
        {
          name: "辽宁",
          area: 21,
          value: 0
        },
        {
          name: "黑龙江",
          area: 23,
          value: 0
        },
        {
          name: "湖南",
          area: 43,
          value: 0
        },
        {
          name: "安徽",
          area: 34,
          value: 0
        },
        {
          name: "山东",
          area: 37,
          value: 0
        },
        {
          name: "新疆",
          area: 65,
          value: 0
        },
        {
          name: "江苏",
          area: 32,
          value: 0
        },
        {
          name: "浙江",
          area: 33,
          value: 0
        },
        {
          name: "江西",
          area: 36,
          value: 0
        },
        {
          name: "湖北",
          area: 42,
          value: 0
        },
        {
          name: "广西",
          area: 45,
          value: 0
        },
        {
          name: "甘肃",
          area: 62,
          value: 0
        },
        {
          name: "山西",
          area: 14,
          value: 0
        },
        {
          name: "内蒙古",
          area: 15,
          value: 0
        },
        {
          name: "陕西",
          area: 61,
          value: 0
        },
        {
          name: "吉林",
          area: 22,
          value: 0
        },
        {
          name: "福建",
          area: 35,
          value: 0
        },
        {
          name: "贵州",
          area: 52,
          value: 0
        },
        {
          name: "广东",
          area: 44,
          value: 0
        },
        {
          name: "青海",
          area: 63,
          value: 0
        },
        {
          name: "西藏",
          area: 54,
          value: 0
        },
        {
          name: "四川",
          area: 51,
          value: 0
        },
        {
          name: "宁夏",
          area: 64,
          value: 0
        },
        {
          name: "海南",
          area: 46,
          value: 0
        },
        {
          name: "台湾",
          area: 71,
          value: 0
        },
        {
          name: "香港",
          area: 81,
          value: 0
        },
        {
          name: "澳门",
          area: 82,
          value: 0
        }
      ]
    };
  },
  methods: {
    //初始化中国地图
    initEchartMap() {
      let mapDiv = document.getElementById('china_map');
      myChart = echarts.init(mapDiv);
      myChart.setOption(this.options);
    },
    //修改echart配制
    setEchartOption() {
      this.options.series[0]['data'] = this.dataList;
    },
    /**
     * 获取数据
     */
    getData() {
      // 区域体检次数
       getTimeArea().then((res) => {
        if (res.code === "0") {
          this.dataList.forEach((item, index) => {
            let value = res.data[item.area];
            if (typeof value != "undefined") {
              this.dataList[index].value = value;
            }
          });
          this.options.series[0]['data'] = this.dataList;
          myChart.setOption(this.options);
        }
      });
    },
  },

  created() {
    this.setEchartOption();
    this.getData();

  },
  mounted() {
    this.$nextTick(() => {
      this.initEchartMap();
    })

  }
};

</script>

<style lang="scss" scoped>
#china_map {
  height: 680px;
}

#china_map .tooltip_style {
  line-height: 1.7;
  overflow: hidden;
}

#china_map .tooltip_left {
  float: left;
}

#china_map .tooltip_right {
  float: right;
}

</style>
